export const SET_SEARCH_PARAM = "SET_SEARCH_PARAM";
export const GET_MERCHANTS_START = "GET_MERCHANTS_START";
export const GET_MERCHANTS_SUCCESS = "GET_MERCHANTS_SUCCESS";
export const GET_MERCHANTS_ERROR = "GET_MERCHANTS_ERROR";

export const SET_TARGET_EMAIL = "SET_TARGET_EMAIL";
export const GET_MERCHANT_DETAILS = "GET_MERCHANT_DETAILS";

export const GET_USERS_START = "GET_USERS_START";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_ERROR = "GET_USERS_ERROR";

export const GET_MERCHANT_SOURCE_SUCCESS = "GET_MERCHANT_SOURCE_SUCCESS";
